import { isWidget } from "@faire/retailer-visitor-shared/lib/signUpRevampUtils";
import { useSignUpRequest } from "@faire/retailer-visitor-shared/views/SignUp/SignUpRequestContext";
import { RetailerRoute } from "@faire/web/common/routes/RetailerRouteMatcher";
import { RouteMatcher } from "@faire/web/common/routes/RouteMatcher";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { route as consumerRoute } from "@faire/web-api--source/routes/www/welcome/r/consumer";
import { route as notifyMeRoute } from "@faire/web-api--source/routes/www/welcome/r/notify-me";
import { route as notifyMeSuccessRoute } from "@faire/web-api--source/routes/www/welcome/r/notify-me/success";
import { route as personalInfoRoute } from "@faire/web-api--source/routes/www/welcome/r/personal";
import { route as owfGrantSocialMediaRoute } from "@faire/web-api--source/routes/www/welcome/r/social-media";
import { useLocation } from "react-router-dom";

const doNotShowImageryPathRouteMatcher = new RouteMatcher<RetailerRoute>([
  notifyMeRoute,
  notifyMeSuccessRoute,
  consumerRoute,
  owfGrantSocialMediaRoute,
]);

const personalInfoRouteMatcher = new RouteMatcher<RetailerRoute>([
  personalInfoRoute,
]);

export const useIsVerticalizedSignUp = () => {
  const [{ isVerticalizedSignUp }] = useSignUpRequest(["isVerticalizedSignUp"]);
  const { isDesktopAndAbove } = useViewport();
  const location = useLocation();
  const doNotShowImageryPath = doNotShowImageryPathRouteMatcher.match(location);
  const isWidgetSignUpFirstStep =
    personalInfoRouteMatcher.match(location) && isWidget(location);

  return (
    isDesktopAndAbove &&
    isVerticalizedSignUp &&
    !doNotShowImageryPath &&
    !isWidgetSignUpFirstStep
  );
};
